import type { Breadcrumb, GenerateBreadcrumbsParams } from '@/entities/breadCrumbs';
import { LocationType } from '@/entities/location';
import { withMfsDomain } from '@/shared/lib/withMfsDomain';

export function generateTourBreadcrumbs(params: GenerateBreadcrumbsParams): Breadcrumb[] {
  const {
    currentTag,
    country,
    citySlug,
    cityName,
    regionSlug,
    regionName,
    countryName,
    rubric,
    rubricTitlesMap,
    locationType,
    isExperienceDetailsPage,
  } = params;

  const resolvedTag = rubric ?? currentTag;
  const isRubricValid = !!rubricTitlesMap[resolvedTag];
  const finalTag = isRubricValid ? resolvedTag : null;
  const isAllTag = currentTag === 'all' || currentTag === '';

  const crumbs: Breadcrumb[] = [{ label: 'Главная', path: `/`, external: true }];
  crumbs.push({ label: 'Все туры', path: `/tours/`, external: true });

  // Добавляем хлебную крошку страны при необходимости
  addCountryBreadcrumb(crumbs, {
    country,
    countryName,
    isCountryPage: locationType === LocationType.COUNTRY,
    isRegionPage: locationType === LocationType.REGION,
    isCityPage: locationType === LocationType.CITY,
    finalTag,
    isExperienceDetailsPage,
  });

  // Добавляем хлебную крошку региона при необходимости
  addRegionBreadcrumb(crumbs, {
    isRegionPage: locationType === LocationType.REGION,
    regionSlug,
    regionName,
    country,
    currentTag,
    rubric,
    rubricTitlesMap,
    finalTag,
    isAllTag,
    isExperienceDetailsPage,
  });

  addCityBreadcrumb(crumbs, {
    citySlug,
    cityName,
    isCityPage: locationType === LocationType.CITY,
    finalTag,
  });

  // Добавляем хлебную крошку рубрики при необходимости
  // Как будто не нужно пока, но вероятно в дальнейшем появится
  // addRubricBreadcrumb(crumbs, {
  //   finalTag,
  //   isCountryPage: locationType === LocationType.COUNTRY,
  //   isRegionPage: locationType === LocationType.REGION,
  //   currentTag,
  //   rubric,
  //   country,
  //   regionSlug,
  //   rubricTitlesMap,
  //   isAllTag,
  //   isExperienceDetailsPage,
  // });

  return crumbs;
}

function addCityBreadcrumb(
  crumbs: Breadcrumb[],
  params: {
    citySlug?: string;
    cityName?: string;
    isCityPage: boolean;
    finalTag: string | null;
  },
): void {
  const { citySlug, cityName, isCityPage, finalTag } = params;

  if (!isCityPage || !citySlug || !cityName) {
    return;
  }

  if (finalTag === 'all' || finalTag === '' || finalTag === null) {
    return;
  }

  crumbs.push({
    label: cityName,
    path: `/tours/city/${citySlug}/`,
  });
}

function addCountryBreadcrumb(
  crumbs: Breadcrumb[],
  params: {
    country?: string;
    countryName?: string;
    isCountryPage: boolean;
    isRegionPage: boolean;
    isCityPage: boolean;
    finalTag: string | null;
    isExperienceDetailsPage?: boolean;
  },
): void {
  const { country, countryName, isRegionPage, isCountryPage, isCityPage, finalTag, isExperienceDetailsPage } = params;

  if (isCountryPage && (finalTag === 'all' || !finalTag)) {
    return;
  }

  if (country && countryName && (isExperienceDetailsPage || isRegionPage || isCountryPage || isCityPage)) {
    crumbs.push({
      label: countryName,
      path: withMfsDomain(`/tours/${country}/`),
      isSpan: Boolean(isCountryPage && (finalTag === 'all' || finalTag === '' || finalTag === null)),
    });
  }
}

function addRegionBreadcrumb(
  crumbs: Breadcrumb[],
  params: {
    isRegionPage: boolean;
    regionSlug?: string;
    regionName?: string;
    country?: string;
    currentTag: string;
    rubric?: string | null;
    rubricTitlesMap: Record<string, string>;
    finalTag: string | null;
    isAllTag: boolean;
    isExperienceDetailsPage?: boolean;
  },
): void {
  const {
    isRegionPage,
    regionSlug,
    regionName,
    country,
    currentTag,
    rubric,
    rubricTitlesMap,
    isAllTag,
    isExperienceDetailsPage,
  } = params;

  if (!isRegionPage || !regionSlug || !regionName) {
    return;
  }

  // Если это страница деталей экспириенса, добавляем регион всегда
  if (isExperienceDetailsPage) {
    crumbs.push({ label: regionName, path: withMfsDomain(`/tours/${country}/${regionSlug}/`) });

    return;
  }

  // Если мы на странице региона с тегом "all" и нет рубрики,
  // то не добавляем регион в хлебные крошки
  if (isRegionPage && isAllTag && !rubric) {
    return;
  }

  const isValidRubricForRegion = rubricTitlesMap[currentTag] && !isAllTag && !rubric;

  // Добавляем регион в хлебные крошки только если:
  // 1. У нас есть валидная рубрика для региона
  // 2. Или у нас есть рубрика (rubric)
  if (isValidRubricForRegion || rubric) {
    crumbs.push({ label: regionName, path: withMfsDomain(`/tours/${country}/${regionSlug}/`) });
  }
}
//
// function addRubricBreadcrumb(
//   crumbs: Breadcrumb[],
//   params: {
//     finalTag: string | null;
//     isCountryPage: boolean;
//     isRegionPage: boolean;
//     currentTag: string;
//     rubric?: string | null;
//     country?: string;
//     regionSlug?: string;
//     rubricTitlesMap: Record<string, string>;
//     isAllTag: boolean;
//     isExperienceDetailsPage?: boolean;
//   },
// ): void {
//   const {
//     finalTag,
//     isCountryPage,
//     isRegionPage,
//     currentTag,
//     rubric,
//     country,
//     regionSlug,
//     rubricTitlesMap,
//     isAllTag,
//     isExperienceDetailsPage,
//   } = params;
//   if (!finalTag || isCountryPage) {
//     return;
//   }
//
//   // Если это страница деталей экспириенса, добавляем рубрику всегда
//   if (isExperienceDetailsPage) {
//     const path = regionSlug
//       ? withMfsDomain(`/tours/${country}/${regionSlug}/tags/${finalTag}`)
//       : withMfsDomain(`/tours/${country}/tags/${finalTag}`);
//
//     crumbs.push({ label: rubricTitlesMap[finalTag], path });
//
//     return;
//   }
//
//   if (isAllTag) {
//     return;
//   }
//
//   if (isRegionPage && currentTag !== 'all') {
//     return;
//   }
//
//   const isRegionWithRubricTest = isRegionPage && currentTag === 'activniy-otdih' && !rubric;
//
//   if (isCountryPage && !isRegionWithRubricTest) {
//     const path =
//       isRegionPage && regionSlug
//         ? withMfsDomain(`/tours/${country}/${regionSlug}/tags/${finalTag}`)
//         : withMfsDomain(`/tours/${country}/tags/${finalTag}`);
//
//     crumbs.push({ label: rubricTitlesMap[finalTag], path });
//   }
// }
